var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isPrint && _vm.selectedWo)?_c('exit-permit-form',{attrs:{"selectedWo":_vm.selectedWo},on:{"goPrint":_vm.goPrint}}):_vm._e(),(_vm.isPrint)?_c('exit-permit-print',{attrs:{"printData":_vm.printData},on:{"goBack":function($event){_vm.isPrint = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }